/* eslint-disable no-debugger */
import { Fragment } from "react";

import useLscTouchpoints from "./UseLSCTouchpoints";
import LSCTouchpointsGrid from "./LSCTouchpointsGrid";

import Headings from "@usas/ui-web/components/headings/Headings";
import ActionIntraPageButton from "@usas/ui-web/components/buttons/ActionIntraPageButton";

const LSCTouchpoints = () => {
  const {
    lscTouchpointSearchState,
    onAddClicked,
    onEditClicked,
    onDeleteClicked
  } = useLscTouchpoints();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>LSC Touchpoints</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-sm-8 col-md-9 usas-extra-top-margin">
          <ActionIntraPageButton type="button" onClick={onAddClicked}>Add Touchpoint</ActionIntraPageButton>
        </div>
      </div>
      <div className="row usas-extra-bottom-margin">
        <div className="col-xs-12">
          <LSCTouchpointsGrid
            data={lscTouchpointSearchState.arrayData}
            isLoading={lscTouchpointSearchState.isLoading}
            onEditClicked={onEditClicked}
            onDeleteClicked={onDeleteClicked} />
        </div>
      </div>
    </Fragment>);
}

export default LSCTouchpoints;
